export default "__VITE_ASSET__D_Q$KgG8__"